import currencyJs from 'currency.js';

export enum ECurrency {
  BDT,
  USD,
  EURO,
  GBP,
}

enum ECurrencySymbol {
  BDT = 'TK',
  USD = '$',
  EURO = '€',
  GBP = '£',
}

export function getCurrencySymbol(currency: ECurrency): ECurrencySymbol {
  switch (currency) {
    case ECurrency.BDT:
      return ECurrencySymbol.BDT;
    case ECurrency.USD:
      return ECurrencySymbol.USD;
    case ECurrency.EURO:
      return ECurrencySymbol.EURO;
    case ECurrency.GBP:
      return ECurrencySymbol.GBP;
    default:
      return ECurrencySymbol.BDT;
  }
}

/**
 * Format Currency Amount
 * @param {number} value - Currency amount.
 * @returns {string} Formatted amount.
 */
export function formatCurrency(value: number): string {
  return currencyJs(value, { symbol: '', precision: 2 }).format();
}
